export const akfConfig = {
  link: 'akf',
  icon: 'book',
  tip: {
    chinese: '知识库',
    english: 'akf',
  },
  uuid: 'KNOWLEDGE_REPO',
  sub: [
    {
      link: 'knowledge',
      icon: 'code-sandbox',
      tip: {
        chinese: '知识点',
        english: 'knowledge',
      },
      uuid: 'KNOWLEDGE_POINT',
      params: [
        { key: 'keywords', required: 'optional', type: 'query' },
        { key: 'examId', required: 'optional', type: 'query' },
        { key: 'courseStandardId', required: 'optional', type: 'query' },
        { key: 'versionId', required: 'optional', type: 'query' },
        {
          key: 'parentKnowledgePointId',
          required: (paths: string[], search: any) => {
            if (
              search.keywords === undefined &&
              search.examId === undefined &&
              search.courseStandardId === undefined &&
              search.versionId === undefined
            ) {
              return 'true';
            }
            return 'optional';
          },
          type: 'query',
          default: 0,
        },
        {
          key: 'subject',
          required: 'true',
          type: 'query',
          default: 'chinese',
        },
      ],
    },
    {
      link: 'version',
      icon: 'file',
      tip: {
        chinese: '版本',
        english: 'version',
      },
      uuid: 'VERSION',
    },
    {
      link: 'standard',
      icon: 'file',
      tip: {
        chinese: '课程标准',
        english: 'standard',
      },
      uuid: 'COURSE_STANDARD',
    },
    {
      link: 'exam',
      icon: 'book',
      tip: {
        chinese: '考试',
        english: 'exam',
      },
      uuid: 'EXAMINATION',
    },
  ],
};
